import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, merge, Observable, Subject } from 'rxjs';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';

import { EntitiesService } from '@core/services/entities/entities.service';
import { ShopSearchParametersService } from '@core/services/shop-search-parameters/shop-search-parameters.service';
import { SettingsStoreSelector } from '@common/selectors/settings.selector';

import {
  SHOPS_MAP_BLOCK_LOADING_VM,
  ShopsMapBlockDataSource,
  ShopsMapBlockViewModel,
} from './shops-map-block-view-model';

@Injectable()
export class ShopsMapBlockStoreDataSource implements ShopsMapBlockDataSource, OnDestroy {
  private readonly destroyed$ = new Subject<boolean>();
  private readonly vmSubject = new BehaviorSubject<ShopsMapBlockViewModel>(
    SHOPS_MAP_BLOCK_LOADING_VM,
  );

  readonly vm$: Observable<ShopsMapBlockViewModel> = this.vmSubject.asObservable();

  constructor(
    private readonly entitiesService: EntitiesService,
    private readonly settingsSelector: SettingsStoreSelector,
    private readonly shopSearchParametersService: ShopSearchParametersService,
  ) {
    merge(
      this.settingsSelector.selectParameters$.pipe(map(() => undefined)),
      this.shopSearchParametersService.getParameters$().pipe(map(() => undefined)),
    )
      .pipe(
        tap(() => this.vmSubject.next(SHOPS_MAP_BLOCK_LOADING_VM)),
        switchMap(() => this.entitiesService.loadProximityEntities$()),
        takeUntil(this.destroyed$),
        tap(entities => {
          this.vmSubject.next({ shops: entities });
        }),
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
